import padStart from "lodash/padStart";

export const convertCents = (c) => {
  return typeof c === "number" ? (c / 100).toFixed(2) : "";
};

export const formatCents = (v) => {
  if (!v) {
    return "00";
  } else {
    return padStart(v.toString(), 2, "0");
  }
};

export function formatNumber(cents) {
  if (typeof cents !== "number") return "";
  return (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2 });
};
